export default "__VITE_ASSET___t2qLu3r__"